import { render, staticRenderFns } from "./OrdersSent.vue?vue&type=template&id=76157f6e&scoped=true&"
import script from "./OrdersSent.vue?vue&type=script&lang=js&"
export * from "./OrdersSent.vue?vue&type=script&lang=js&"
import style0 from "./OrdersSent.vue?vue&type=style&index=0&id=76157f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76157f6e",
  null
  
)

export default component.exports